import { type JSX, Show } from 'solid-js'
import { HMPendingApprovalPage } from '../../features/auth-shared/HMPendingApprovalPage'
import { authStore } from '../../stores/auth.store'

interface PendingApprovalGateProps {
  children: JSX.Element
}

export function PendingApprovalGate(props: PendingApprovalGateProps) {
  return (
    <Show when={authStore.isHMApproved} fallback={<HMPendingApprovalPage />}>
      {props.children}
    </Show>
  )
}
